var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{class:[_vm.color ? _vm.color + '--text' : null, _vm.spin ? 'fa-spin' : null, _vm.iconOnly ? 'mr-4' : null],attrs:{"size":"lg","icon":'far ' + _vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }